import React from 'react'
import PropTypes from 'prop-types'
import { IonContent, IonPage } from '@ionic/react'
import { Header, BackToSearchButton } from 'components'

const propTypes = {
  children: PropTypes.node.isRequired,
  showBackToSearch: PropTypes.bool,
}
const defaultProps = {
  showBackToSearch: false,
}

function Layout({ children, showBackToSearch }) {
  return (
    <IonPage
      className={showBackToSearch ? 'manager-order-show-page' : undefined}
    >
      <Header />
      {showBackToSearch && (
        <div className="manager-order-show__panel-wrapper manager-order-show__panel-wrapper--back">
          <BackToSearchButton to="/manager/dashboard" label="Go Back" />
        </div>
      )}
      <IonContent className="background-content">{children}</IonContent>
    </IonPage>
  )
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

export default Layout
